import React from "react";
import { NewTab, PageTab } from "../../../../components";
import AvatarList from "./OtherList/AvatarList";
import CopyToClipboardList from "./OtherList/CopyToClipboardList";
import DividerList from "./OtherList/DividerList";
import GroupAvatarList from "./OtherList/GroupAvatarList";
import DragAndDropList from "./OtherList/DragAndDropList";
import HorizontalScaleList from "./OtherList/HorizontalScaleList";
import DualIconList from "./OtherList/DualIconList";
import ExpandableWrapperList from "./OtherList/ExpandableWrapperList";
import ProgressBarList from "./OtherList/ProgressBarList";

const OtherList = () => {
  const tabList = [
    {
      title: "Avatar",
      page: <AvatarList />,
      type: "main",
    },
    {
      title: "Copy To Clipboard",
      page: <CopyToClipboardList />,
      type: "main",
    },
    {
      title: "Divider",
      page: <DividerList />,
      type: "main",
    },
    {
      title: "Group Avatar",
      page: <GroupAvatarList />,
      type: "main",
    },
    {
      title: "Drag and Drop",
      page: <DragAndDropList />,
      type: "main",
    },
    {
      title: "Horizontal Scale",
      page: <HorizontalScaleList />,
      type: "main",
    },
    {
      title: "Dual Icon",
      page: <DualIconList />,
      type: "main",
    },
    {
      title: "Bar Chart With Wrapper",
      page: <ExpandableWrapperList />,
      type: "main",
    },
    {
      title: "Progress Bar",
      page: <ProgressBarList />,
      type: "main",
    },
  ];
  return (
    <div className="mt-5 flex-1 flex overflow-hidden">
      <NewTab
        tabs={tabList}
        color="black"
        variant="text"
        activeVariant="text"
        mode="url"
        tabId="other-list"
      />
    </div>
  );
};

export default OtherList;
